function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#EB506E"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M63.624 15.734L48.266.376C48.035.143 47.715 0 47.36 0H6.4C2.871 0 0 2.871 0 6.4v66.56c0 3.529 2.871 6.4 6.4 6.4h51.2c3.529 0 6.4-2.871 6.4-6.4V16.64c0-.355-.143-.675-.376-.906zM48.64 4.37l10.99 10.99H48.64V4.37zm12.8 68.59c0 2.117-1.723 3.84-3.84 3.84H6.4c-2.117 0-3.84-1.723-3.84-3.84V6.4c0-2.117 1.723-3.84 3.84-3.84h39.68v14.08c0 .707.572 1.28 1.28 1.28h14.08v55.04z",
  transform: "translate(-239 -348) translate(239 348)"
}), /*#__PURE__*/React.createElement("text", {
  fontFamily: "DMSans-Bold, DM Sans",
  fontSize: 21,
  fontWeight: "bold",
  letterSpacing: -0.458,
  transform: "translate(-239 -348) translate(239 348)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 12,
  y: 49
}, "APK")))));

var SvgApk = function SvgApk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 80,
    viewBox: "0 0 64 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/apk.e79a397f.svg";
export { ForwardRef as ReactComponent };